import * as React from 'react';
import { connect } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
// tslint:disable-next-line:no-unused-variable
import { ICrudGetAction, TextFormat } from 'react-jhipster';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

import { IRootState } from 'app/shared/reducers';
import { getEntity } from './book-subscription.reducer';
import { IBookSubscription } from 'app/shared/model/book-subscription.model';
// tslint:disable-next-line:no-unused-variable
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';

export interface IBookSubscriptionDetailProps extends StateProps, DispatchProps, RouteComponentProps<{ id: number }> {}

export class BookSubscriptionDetail extends React.Component<IBookSubscriptionDetailProps> {
  componentDidMount() {
    this.props.getEntity(this.props.match.params.id);
  }

  render() {
    const { bookSubscriptionEntity } = this.props;
    return (
      <Row>
        <Col md="8">
          <h2>
            BookSubscription [<b>{bookSubscriptionEntity.id}</b>]
          </h2>
          <dl className="jh-entity-details">
            <dt>
              <span id="isActive">Is Active</span>
            </dt>
            <dd>{bookSubscriptionEntity.isActive ? 'true' : 'false'}</dd>
            <dt>
              <span id="subscriptionStartDate">Subscription Start Date</span>
            </dt>
            <dd>
              <TextFormat value={bookSubscriptionEntity.subscriptionStartDate} type="date" format={APP_DATE_FORMAT} />
            </dd>
            <dt>
              <span id="subscriptionEndDate">Subscription End Date</span>
            </dt>
            <dd>
              <TextFormat value={bookSubscriptionEntity.subscriptionEndDate} type="date" format={APP_DATE_FORMAT} />
            </dd>
            <dt>
              <span id="createdDate">Created Date</span>
            </dt>
            <dd>
              <TextFormat value={bookSubscriptionEntity.createdDate} type="date" format={APP_DATE_FORMAT} />
            </dd>
            <dt>
              <span id="lastModifiedDate">Last Modified Date</span>
            </dt>
            <dd>
              <TextFormat value={bookSubscriptionEntity.lastModifiedDate} type="date" format={APP_DATE_FORMAT} />
            </dd>
            <dt>Book</dt>
            <dd>{bookSubscriptionEntity.book ? bookSubscriptionEntity.book.name : ''}</dd>
            <dt>Created By</dt>
            <dd>{bookSubscriptionEntity.createdBy ? bookSubscriptionEntity.createdBy.login : ''}</dd>
            <dt>Last Modified By</dt>
            <dd>{bookSubscriptionEntity.lastModifiedBy ? bookSubscriptionEntity.lastModifiedBy.login : ''}</dd>
            <dt>User</dt>
            <dd>{bookSubscriptionEntity.user ? bookSubscriptionEntity.user.email : ''}</dd>
          </dl>
          <Button tag={Link} to="/entity/book-subscription" replace color="info">
            <FontAwesomeIcon icon="arrow-left" /> <span className="d-none d-md-inline">Back</span>
          </Button>&nbsp;
          <Button tag={Link} to={`/entity/book-subscription/${bookSubscriptionEntity.id}/edit`} replace color="primary">
            <FontAwesomeIcon icon="pencil-alt" /> <span className="d-none d-md-inline">Edit</span>
          </Button>
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = ({ bookSubscription }: IRootState) => ({
  bookSubscriptionEntity: bookSubscription.entity
});

const mapDispatchToProps = { getEntity };

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(BookSubscriptionDetail);
